<div class="popup-container">

<header>
  <button class="close_button" type="button" cdkFocusInitial (click)="close()" aria-label="Close dialog">x</button>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{ heading }}</label>
  </div>
</header>

<div class="grid-agg p-0">
  <app-notification-message class="mt-3" [errorMessage]="errorMessage" [successMessage]="successMessage">
  </app-notification-message>
  <ag-grid-angular class="ag-theme-balham grid-items m-3 childgrid" [columnDefs]="columnDefs" [rowData]="displayRowData"
    [defaultColDef]="defaultColDef" [headerHeight]="40" [rowHeight]="rowHeight" 
    [context]="context" [theme]="'legacy'"></ag-grid-angular>
</div>
</div>